import { useHistory } from 'react-router-dom';

export type AiAgentNavigationState = {
  initialMessage?: string;
  autoSend?: boolean;
  handoff?: boolean;
};

type NavigateToAiAgentParams = {
  societyId: string;
  initialMessage?: string;
  autoSend?: boolean;
  handoff?: boolean;
};

export const useNavigateToAiAgent = () => {
  const history = useHistory();

  return ({
    societyId,
    initialMessage,
    autoSend = true,
    handoff = false,
  }: NavigateToAiAgentParams) => {
    if (!societyId) return;

    if (handoff) {
      history.push(`/sociedad-ai/${societyId}`, { handoff: true } as AiAgentNavigationState);
      return;
    }

    const trimmed = initialMessage?.trim();
    if (!trimmed) return;

    history.push(`/sociedad-ai/${societyId}`, {
      initialMessage: trimmed,
      autoSend,
    } as AiAgentNavigationState);
  };
};
